import { StringsEnumDimension } from '@orus.eu/dimensions'
import { esRcphProductVersions } from '@orus.eu/product'

export const esRcphProductVersionDimension = new StringsEnumDimension({
  name: 'esRcphProductVersion',
  displayKeys: { name: 'dimension_name_es_rcph_product_version' },
  values: esRcphProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
})
